module.exports = __webpack_public_path__ + "img/015.7f4320b5.png";